<template>
	<div>
		<div
			v-if="$route.name === 'list'"
			class="question-list-container" :style="`background-color:${$appColors.white}`"
		>
			<app-table
				icon-excel
				name="question-list"
				title="Lista de Respuestas"
				:clean-search="cleanSearch"
				:filter-columns="false"
				:rows="answers"
				:columns="columns"
				:main-list="false"
				class="question-list is-not-selectable"
				@on-search-event="onSearch"
			>
				<template slot="excel">
					<button type="button" class="new-question-btn"
						@click="goTo('new-answer')"
					>
						<answer-icon :color="$appColors.primary"/>
					</button>
				</template>
				<template slot="rows" slot-scope="{ row }">
					<td v-show="showRow(columns, 1)" class="is-not-selectable border-top">{{ row.name }}</td>
					<td v-show="showRow(columns, 2)" class="border-top">{{ row.details.length }}</td>
					<td v-show="showRow(columns, 3)" class="border-top">{{ row.typeAnswer.name }}</td>
					<td v-show="showRow(columns, 4)" class="border-top">
						<v-layout wrap align-center justify-start>
							<app-tooltip-button
								text="Editar"
								img="https://s3.amazonaws.com/apprunn-acl/COM-PRU-01/ARQ88/image/new-file-1-(4).svg"
								@click-icon="editTool(row)"
							/>
							<app-tooltip-button
								v-if="row.flagDelete"
								img="https://s3.amazonaws.com/apprunn-acl/COM-PRU-01/ARQ88/image/delete-button-(1).svg"
								text="Eliminar"
								color="info"
								@click-icon="deleteTool(row)"
							/>
						</v-layout>
					</td>
				</template>
			</app-table>
			<div class="buttons-container" v-if="answers.length === 0">
				<app-button
					class="btn-tool"
					text="Nueva Pregunta"
					icon="add"
					:style="`background-color:${$appColors.primary}`"
				></app-button>
			</div>
		</div>
		<router-view name="answerNew"></router-view>
		<router-view name="answerEdit"></router-view>
	</div>
</template>
<script>
import { mapState } from 'vuex';
import answerIcon from '@/components/shared/icons/answer-icon';
import appButton from '@/components/shared/app-button';

function created() {
	this.$store.dispatch('answer/loadAnswers');
}

function onSearch() {}

function editTool(answer) {
	this.goTo('edit-answer', { params: { id: answer.id } });
}

function deleteTool({ id }) {
	this.$store.dispatch('answer/deleteAnswer', { answerId: id });
}

function data() {
	return {
		cleanSearch: false,
		columns: [
			{
				id: 1,
				name: 'Nombre',
				value: 'name',
				checked: false,
				visible: true,
			},
			{
				id: 2,
				name: 'Alternativas',
				value: 'description',
				checked: false,
				visible: true,
			},
			{
				id: 3,
				name: 'Tipo',
				value: 'type',
				checked: false,
				visible: true,
			},
			{
				id: 4,
				name: 'Acciones',
				checked: false,
				visible: true,
			},
		],
	};
}

export default {
	name: 'answer-list',
	components: {
		appButton,
		answerIcon,
	},
	computed: {
		...mapState('answer', {
			answers: state => state.answers.list,
		}),
	},
	created,
	data,
	methods: {
		deleteTool,
		editTool,
		onSearch,
	},
};
</script>
<style lang="scss" scoped>
.question-list-container {
	border-radius: 4px;
	box-shadow: 0 2px 7px 0 rgba(0, 0, 0, 0.02);

	.new-question-btn {
		background: none;
		border: none;
		height: auto;
	}

	.question-list {
		border: none !important;
		box-shadow: none;
	}
}
.buttons-container {
	align-items: center;
	height: 200px;
	display: flex;
	justify-content: center;
}
</style>


// WEBPACK FOOTER //
// src/components/configuration/answer/answer-list.vue